<template>
  <Teleport v-if="inQuestionModal" defer to="#question-modal-footer">
    <div class="w-full">
      <PrimaryButton
        v-if="showNext"
        class="w-full"
        :class="{
          'cursor-pointer opacity-100': canProceed,
          'cursor-not-allowed opacity-50': !canProceed
        }"
        :size="'xl'"
        :streaking="canProceed"
        @click="$emit('next')"
      >
        <span>{{ actionText }}</span>
        <template #left-icon><span class="h-4 w-4"></span></template>
        <template #right-icon><ArrowRightIcon class="h-4" /></template>
      </PrimaryButton>
      <div v-if="showSkip" class="flex justify-end" :class="{ 'mt-3': showNext }">
        <button
          type="button"
          class="text-sm text-gray-brand-700 underline hover:text-gray-brand-900 rounded focus:outline-none focus:ring-2 focus:ring-brand-900"
          @click="$emit('skip')"
        >
          Skip question
        </button>
      </div>
    </div>
  </Teleport>
  <div v-else>
    <div v-if="showNext" class="p-4 pt-0 mt-1">
      <PrimaryButton
        @click="$emit('next')"
        class="w-full"
        :class="{
          'cursor-pointer opacity-100': canProceed,
          'cursor-not-allowed opacity-50': !canProceed
        }"
        :size="'xl'"
        :streaking="canProceed"
        :justify="'justify-center'"
      >
        {{ actionText }}
      </PrimaryButton>
    </div>
    <div v-if="showSkip" class="p-4 pt-0 -mt-1">
      <SecondaryButton class="w-full" :size="'xl'" @click="$emit('skip')">Skip Question</SecondaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from '@/components/Molecules/PrimaryButton'
import SecondaryButton from '@/components/Molecules/SecondaryButton'
import { ArrowRightIcon } from '@heroicons/vue/solid'

export default {
  name: 'QuestionFooterButtons',

  components: {
    PrimaryButton,
    SecondaryButton,
    ArrowRightIcon
  },

  inject: {
    inQuestionModal: { default: false }
  },

  props: {
    actionText: {
      type: String,
      default: 'Next'
    },
    canProceed: {
      type: Boolean,
      default: true
    },
    showSkip: {
      type: Boolean,
      default: false
    },
    showNext: {
      type: Boolean,
      default: true
    }
  },

  emits: ['next', 'skip']
}
</script>
